import React from "react";
import { Check } from "lucide-react";
import { Link } from "react-router-dom";

export default function PackageCards({ serviceSlug, packages }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
      {packages.map((p) => (
        <div
          key={p.id}
          className={`card-soft p-7 flex flex-col ${p.highlight ? "ring-2 ring-terra" : ""}`}
          data-testid={`package-card-${p.id}`}
        >
          {p.highlight && (
            <div className="self-start tag tag-accent mb-5">Most popular</div>
          )}
          <div className="font-display text-xl font-semibold tracking-tight">{p.name}</div>
          <div className="mt-3 flex items-baseline gap-1.5">
            <span className="font-mono text-4xl font-semibold tracking-tighter">${p.price}</span>
            <span className="text-xs text-inkSoft">/order</span>
          </div>
          <div className="mt-2 text-xs text-inkSoft">Turnaround · {p.turnaround}</div>
          <ul className="mt-6 space-y-3 text-sm flex-1">
            {p.features.map((f) => (
              <li key={f} className="flex items-start gap-2">
                <Check size={16} className="text-terra mt-0.5 shrink-0" />
                <span className="text-ink/85">{f}</span>
              </li>
            ))}
          </ul>
          <Link
            to={`/signup?service=${serviceSlug}&package=${p.id}`}
            className={`mt-7 inline-flex items-center justify-center gap-2 px-5 py-3 rounded-xl text-sm font-semibold transition ${
              p.highlight ? "bg-terra text-white hover:bg-terra-hover" : "border border-ink text-ink hover:bg-ink hover:text-white"
            }`}
            data-testid={`package-cta-${p.id}`}
          >
            Order this package
          </Link>
        </div>
      ))}
    </div>
  );
}
